export const permissionsList = {
  AddPatient: 'add-patient',
  RemovePatient: 'remove-patient',
  ViewPatient: 'view-patient',
  AddAppointment: 'add-appointment',
  CancelAppointment: 'cancel-appointment',
  ViewAppointment: 'view-appointment',
  CreateUser: 'create-user',
  DeleteUser: 'delete-user',
  ViewUser: 'view-user',
  AddRole: 'add-role',
  RemoveRole: 'remove-role',
  ViewRole: 'view-role',
  AddPermission: 'add-permission',
  RemovePermission: 'remove-permission',
  ViewPermission: 'view-permission',
  ClinicalManager: 'clinical-manager',
  AndrologyManager: 'andrology-manager',
  EmbrologyManager: 'embrology-manager',
  FreezingNotifications: 'freezing-notifications',
};

export const permissionsWithAssignedIds = {
  [permissionsList.AddPatient]: 1,
  [permissionsList.RemovePatient]: 2,
  [permissionsList.ViewPatient]: 3,
  [permissionsList.AddAppointment]: 4,
  [permissionsList.CancelAppointment]: 5,
  [permissionsList.ViewAppointment]: 6,
  [permissionsList.CreateUser]: 7,
  [permissionsList.DeleteUser]: 8,
  [permissionsList.ViewUser]: 9,
  [permissionsList.AddRole]: 10,
  [permissionsList.RemoveRole]: 11,
  [permissionsList.ViewRole]: 12,
  [permissionsList.AddPermission]: 13,
  [permissionsList.RemovePermission]: 14,
  [permissionsList.ViewPermission]: 15,
  [permissionsList.ClinicalManager]: 16,
  [permissionsList.AndrologyManager]: 17,
  [permissionsList.EmbrologyManager]: 18,
  [permissionsList.FreezingNotifications]: 19,
};
